import { Language } from '../../core/i18n/constants';
import { useLanguage } from '../../core/i18n/hooks/use-language';
import { BASE_BACKEND_QUERY_KEY, BASE_BACKEND_URL, QUERY_KEYS } from '../backend/constants';
import { useAnonymousQuery } from '../backend/hooks/use-anonymous-query';
import { GetSeriesResponse } from '../backend/openapi/api-types';

const seriesUrls = {
  getSeries: () => `${BASE_BACKEND_URL}/series` as const,
};

const seriesQueryKeys = {
  series: (language: Language) => [BASE_BACKEND_QUERY_KEY, language, QUERY_KEYS.series],
};

export const useSeriesQuery = () => {
  const language = useLanguage();
  return useAnonymousQuery<GetSeriesResponse>({
    options: {
      queryKey: seriesQueryKeys.series(language),
    },
    url: seriesUrls.getSeries(),
  });
};
